import React, { useEffect } from 'react';
import { BusinessHeader, Header, PointSettings } from 'widgets';
import { useNavigate, useParams } from 'react-router-dom';
import { businessStore, userStore } from 'entities/index';
import { PageLayout } from 'shared/ui';
export const PointSettingsPage: React.FC = () => {
  const { id } = useParams();
  const pointId = id;
  useEffect(() => {
    if (pointId) {
      businessStore.initPointHeaderData(pointId);
    }
  }, []);
  const navigate = useNavigate();
  useEffect(() => {
    if (!pointId) {
      userStore.redirectToRoleBasedPage(navigate);
    }
  }, []);

  return (
    <PageLayout>
      <Header />
      <BusinessHeader isSettings={false} pointPage={true} />
      <PointSettings />
    </PageLayout>
  );
};
